// extracted by mini-css-extract-plugin
module.exports = {"container":"oddIcon__container___2kp-x","is-completed":"oddIcon__is-completed___3Zm4K","is-processing":"oddIcon__is-processing___33soD","loading":"oddIcon__loading___2LhDv"};